export const BUYERS_OPTIONS = [
  {
    label: 'Hooikammer verkoper',
    value: 1,
  }
];
